export default __webpack_public_path__ + "static/media/Learn-Islamic-Studies-Online-for-kids-and-Adults.8757f8b4.png";